export default __webpack_public_path__ + "static/media/Snd1.6b2e38f3.mp3";